import { memo, useRef, useState } from 'react';
import cn from 'classnames';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { useOutsideClick } from '@zmedia/bm-soccer-ui/hooks';
import {
    Button,
    Element,
    Icon,
    RouterLink,
} from '@zmedia/bm-soccer-ui/components';
import styles from './style.module.scss';

interface ISeason {
    id: number;
    name: string;
}

export function SelectSeason({
    seasons = [],
    seasonId,
    url,
    seasonName,
}: {
    seasons: ISeason[];
    seasonId: number;
    url: string;
    seasonName: string;
}) {
    const [open, toggleOpen] = useState<boolean>(false);
    const selectRef = useRef(null);

    const handleClickOutside = (isInside: boolean) => {
        if (!isInside) {
            setTimeout(() => toggleOpen(false), 100);
        }
    };

    useOutsideClick(selectRef, handleClickOutside);

    const renderSeason = (item: ISeason, index: number) => {
        return (
            <RouterLink
                to={`${url}/?seasonId=${item.id}`}
                className={cn(styles['season-item'], {
                    [styles['is-select']]: item.id === seasonId,
                })}
                key={index}
                title={item.name}
            >
                <Element className={styles['select-text']}>{item.name}</Element>
            </RouterLink>
        );
    };

    const renderSeasons = (seasons: ISeason[]) => {
        return seasons.map((season: ISeason, index: number) => {
            return renderSeason(season, index);
        });
    };

    if (ArrayUtils.isEmpty(seasons)) {
        return null;
    }

    return (
        <Element className={styles['select-season']}>
            <Button
                className={styles['btn-select']}
                onClick={() => toggleOpen(!open)}
                domRef={selectRef}
            >
                {seasonName}
                {seasons.length > 0 && (
                    <Icon icon={open ? 'up' : 'down'}></Icon>
                )}
            </Button>

            {open && seasons.length > 0 && (
                <Element className={styles['season-items']}>
                    {renderSeasons(seasons)}
                </Element>
            )}
        </Element>
    );
}

export default memo(SelectSeason);
